import VideoPreview from './VideoPreview.vue'

export interface Props {
  link: string
}

export default VideoPreview